
import React from "react"

import { CardText, Row, Col } from "reactstrap"
import DPTextBoxAlign from "framework/components/DPTextBoxAlign"


const UserPoliciesTab1 = props => {
  const dateset = [{
    groupTag:"110000",
    groupDep:"Invantory Reporter"},
    {
      groupTag:"110001",
      groupDep:"Invantory Reporter"},
      {
        groupTag:"110002",
        groupDep:"Invantory Reporter"},];


 return (
   <React.Fragment>
     <div style={{paddingTop:"1rem"}}>
       <Row>
         <Col sm="12">
           <CardText className="mb-0">
             <Row>
               <Col sm={12} md={12} className="mb-4-sm">
                 <div className="inner-repeater mb-4">
                 <table class="table table-sm">
                        <thead>
                            <tr>
                            <th scope="col">Menu Tag</th>
                            <th scope="col">Description</th>
                             <th scope="col">Access</th>
                             <th scope="col">Create</th>
                             <th scope="col">Modify</th>
                             <th scope="col">Delete</th>
                             <th scope="col">Process</th>
                            </tr>
                      </thead>
                     <tbody>
                     {dateset.map((records, key) => (
                         <tr key={key}>
                  
                              <td>{records.groupTag}</td>
                              <td>{records.groupDep}</td>
                              <td><div style={{paddingRight:"4rem"}}><DPTextBoxAlign/></div></td>
                              <td><div style={{paddingRight:"4rem"}}><DPTextBoxAlign/></div></td>
                              <td><div style={{paddingRight:"4rem"}}><DPTextBoxAlign/></div></td>
                              <td><div style={{paddingRight:"4rem"}}><DPTextBoxAlign/></div></td>
                              <td><div style={{paddingRight:"4rem"}}><DPTextBoxAlign/></div></td>
                         </tr>
                     ))}
                     </tbody>
                   </table>
                 </div>
               </Col>
             </Row>
           </CardText>
         </Col>
       </Row>
     </div>
   </React.Fragment>
 )
}
export default UserPoliciesTab1
